// src/components/common/Footer/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ExternalLink } from 'lucide-react';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLeft}>
          <p className={styles.footerText}>
            © {currentYear} Rettzy.{' '}
            <span className={styles.footerLove}>
              Made with{' '}
              <Heart size={12} className={styles.heartIcon} fill="currentColor" />
              {' '}for Sri Lankan businesses
            </span>
          </p>
        </div>
        
        <div className={styles.footerRight}>
          <div className={styles.footerLinks}>
            <Link to="/help" className={styles.footerLink}>
              Help
            </Link>
            <Link to="/privacy" className={styles.footerLink}>
              Privacy
            </Link>
            <Link to="/terms" className={styles.footerLink}>
              Terms
            </Link>
            <a 
              href="https://docs.example.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className={`${styles.footerLink} ${styles.external}`}
            >
              Docs
              <ExternalLink size={10} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;